import { notNull } from '~/_shared/utils/typeGuards';
import { isDataLayersArtificialBoundaryTerritoryGroup } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/dataLayersTool.helpers';
import { ActiveDataLayerContainer } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/listing/activeDataLayer.container';
import { useDataLayersToolBTGsGroupedByBoundaryGroupSelector } from '~/store/boundaryTerritoryGroups/dataLayersTool/dataLayersBTGs.selectors';
import { useMapSettingsDataLayersInstancesSelector } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.selectors';

export const DataLayersToolListingContainer = () => {
  const boundaryTerritoryGroupsByBoundaryGroupId = useDataLayersToolBTGsGroupedByBoundaryGroupSelector();
  const dataLayers = useMapSettingsDataLayersInstancesSelector();

  return (
    <>
      {boundaryTerritoryGroupsByBoundaryGroupId
        .map(({ boundaryGroupId, boundaryTerritoryGroups }) => {
          const firstGroup = boundaryTerritoryGroups[0] || boundaryTerritoryGroups[1];

          if (!firstGroup) {
            return null;
          }

          const dataLayer = dataLayers.find(dl =>
            isDataLayersArtificialBoundaryTerritoryGroup(firstGroup)
              && firstGroup.settings.connectedEntityData?.id === dl.id
          );

          if (!dataLayer) {
            return null;
          }

          return (
            <ActiveDataLayerContainer
              key={boundaryGroupId}
              boundaryGroupId={boundaryGroupId}
              boundaryTerritoryGroups={boundaryTerritoryGroups}
              dataLayer={dataLayer}
            />
          );
        }).filter(notNull)}
    </>
  );
};
